import React, {
	PureComponent
} from "react";
import {
	StyleSheet,
	TouchableOpacity,
	View
} from "react-native";

import Style from "ae-style";
import PropTypes from "prop-types";
import StyledIcon from "ae-base/Base/StyledIcon";
import StyledText from "ae-base/Base/StyledText";
import par from "par";

import MediaStreamRecorder from "msr";

const SEC_PER_MIN = 60;
const MAX_RECORDING_SEC = 10 * SEC_PER_MIN;
const WARNING_DURATION = 0.5 * SEC_PER_MIN;

var styles = StyleSheet.create({
	inputStyle: {
		flexDirection: "row",
		marginVertical: Style.layout.marginContentSmall / 2,
		marginLeft: Style.layout.marginSlim,
		marginRight: Style.layout.marginSmall,
		paddingVertical: Style.layout.paddingSmall / 2,
		alignItems: "center"
	},
	iconStyle: {
		borderColor: Style.look.text,
		marginRight: Style.layout.marginSmall,
	},
	stretch: {
		alignSelf: "stretch",
		alignItems: "center"
	}
});

export default class AudioRecorder extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			currentTime: 0.0,
			warning: false,
			permissionStatus: "prompt",
			recording: false
		};
		this.streamRecorder = null;
		this.timerInterval = null;

		this.registerPermissionListener = registerPermissionListener.bind(this);
		this.startRecording = startRecording.bind(this);
		this.stopRecording = stopRecording.bind(this);
		this.toggleState = toggleState.bind(this);
		this.updateTime = updateTime.bind(this);
		this.startMSR = startMSR.bind(this);
		this.onStop = onStop.bind(this);

	}

	componentDidMount() {
		this.registerPermissionListener();
	}

	componentWillUnmount() {
		if (this.timerInterval)
			clearInterval(this.timerInterval);
	}

	render(){
		var context = this.context;
		var props = this.props;
		const recording = this.state.recording;
		var title = props.title;

		if (recording) {
			title = context.localize("form.activerecording");
			const remainingMins = Math.floor((MAX_RECORDING_SEC - this.state.currentTime) / (SEC_PER_MIN));
			var remainingSecs = (MAX_RECORDING_SEC - this.state.currentTime) % SEC_PER_MIN;
			if (remainingSecs < 10)
				remainingSecs = "0" + remainingSecs;
			title += ` (${remainingMins}:${remainingSecs} ${context.localize("form.timeremaining")})`;
		} else if (this.state.permissionStatus === "denied") {
			title += ` (${context.localize("form.blockedmicrophone")})`;
		}

		const iconName = recording ? "fa-stop-circle" : "fa-circle";
		const warning = this.state.currentTime > (MAX_RECORDING_SEC - WARNING_DURATION);
		var touchStyle = [];
		if (props.stretch) {
			touchStyle.push(styles.stretch);
		}

		return (
			<TouchableOpacity id={context.id_prefix + "audio_recorder"} style={touchStyle}
				accessibilityComponentType="button" onPress={this.toggleState}>
				<View style={styles.inputStyle}>
					<StyledIcon style={styles.iconStyle} red large name={iconName} />
					<StyledText bold red={warning}>
						{title}
					</StyledText>
				</View>
			</TouchableOpacity>
		);
	}
}

AudioRecorder.contextTypes = {
	localize: PropTypes.func
};

// On mount functions
function registerPermissionListener() {
	var component = this;
	const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
	if (isChrome)
		navigator.permissions.query({
			name: "microphone"
		}).then(function(status) {
				component.setState({
					permissionStatus: status.state
				});
				status.onchange = function() {
					component.setState({
						permissionStatus: status.state
					});
				};
			}
		);
	else
		this.setState({
			permissionStatus: "granted", // We are unable to check permissions in firefox, so we set to "granted" and prompt access for every use
		});
}

// Recording functions
function toggleState() {
	if (this.state.permissionStatus !== "granted" && !this.state.recording) {
		// Prompt access by opening and closing a stream
		navigator.mediaDevices.getUserMedia({
			audio: true
		}).then(handleMediaSuccess.bind(this)).catch(handleError.bind(this));
	}	else if(this.state.recording){
		this.stopRecording();
	} else {
		this.startRecording();
	}
}

function handleMediaSuccess(stream){
	stream.getTracks().forEach(track => track.stop());
	this.setState({
		permissionStatus: "granted",
	});
}

function handleError(error){
	console.log(error);
	this.setState({
		permissionStatus: "denied"
	});
}

function startRecording() {
	navigator.getUserMedia({ audio: true }, this.startMSR, handleError.bind(this));
	this.setState({
		recording: true,
	});
	this.timerInterval = setInterval(this.updateTime, 1000);

}

function startMSR(stream) {
	this.streamRecorder = new MediaStreamRecorder(stream);
	this.streamRecorder.stream = stream;
	this.streamRecorder.mimeType = "audio/wav";
	this.streamRecorder.ondataavailable = this.onStop;
	this.streamRecorder.start((MAX_RECORDING_SEC + 1)*1000); //ms
}

function stopRecording() {
	this.setState({
		recording: false,
		currentTime: 0,
	});
	this.streamRecorder.stop()
	clearInterval(this.timerInterval);
}

function onStop(recordedBlob) {
	if (this.props.onAdd) {
		var date = new Date;
		var type = recordedBlob.type;
		var extension = type.split("/")[1];
		var name = makeFilename(date) + "." + extension;
		var file = new File([recordedBlob], name, {
			lastModified: date
		});
		file.type = recordedBlob.type;
		file.format = "audio";
		file.url = window.URL.createObjectURL(recordedBlob);
		this.props.onAdd(file);
	} else {
		console.error("ERROR props.onAdd not found");
	}
	this.streamRecorder.stream.getTracks().forEach(track => track.stop());
}

function makeFilename(date) {
	var str = date.getFullYear() + "_";
	str += (date.getMonth() + 1) + "_";
	str += date.getDate() + "_";
	str += date.toTimeString().substr(0, 8).replace(/:/gi, "_");
	return str;
}

// Timer functions
function updateTime() {
	if (!this.state.recording) {
		this.setState({
			currentTime: 0
		});
	} else {
		if (this.state.currentTime >= MAX_RECORDING_SEC) {
			this.stopRecording();
		} else {
			this.setState({
				currentTime: this.state.currentTime + 1
			});
		}
	}
}
